export const clinic = {
  brandName: 'Amorim',
  brandTagline: 'Saúde Integrativa',
  coverImage:
    'https://cdn.magicpatterns.com/patterns/generated-images/5654ba3c-7c13-466e-b4c4-4e1e0eb366d9.jpg',
  formName: 'Pré-avaliação',
  specialistName: 'Dr. Rafael Amorim',
  specialistRole: 'Quiropraxia · Seitai · Saúde Integrativa',
  location: 'Aracruz · ES',
  credential: '+3.800 atendimentos',
  welcome:
    'Antes da sua avaliação, cinco perguntas rápidas para eu entender a causa do seu desconforto — e não apenas o sintoma.',
  duration: 'Menos de 2 minutos',
  thankYouTitle: 'Recebemos suas respostas.',
  thankYouBody:
    'Vou revisar pessoalmente o que você contou antes do atendimento, para investigarmos a origem do desconforto: estrutura corporal, microbiota e metabolismo em um único plano de cuidado.',
  contact:
    'Nossa equipe entra em contato pelo WhatsApp para confirmar o melhor horário na clínica em Aracruz.',
};
